import api from "../../api";

export const getNotificationsList = async (params: any) => {
    const { data } = await api.get('account/notifications', {params: params});

    return data
}

export const makeNotificationsRead = async (id: number) => {
    const { data } = await api.get(`account/notifications/${id}/read`);
    return data
}

export const makeNotificationsReadAll = async (params: any) => {
    const { data } = await api.post(`account/notifications/read_all`, params);
    return data
}